<template>
  <div class="text-date-filter">
    <RInput
      placeholder="search"
      is-search
      no-label
      no-hint
      no-feedback-icon
      :value="model"
      :debounce="800"
      @input="valueChanged"
    >
      <template #append-more>
        <q-icon color="tertiary" class="info-icon" size="1.3rem" name="help_outline">
          <LmTooltip>
            Type a year "2016", "2017" <br />
            Type a specific date in CUSTOM format, so "12/31/2019" (MM/DD/YYYY) or "31/12/2019" (DD/MM/YYYY) <br />
            Type a range in CUSTOM format "01/01/2019..12/31/2019" OR "01/01/2019..31/12/2019" by using two dots between
            two dates
          </LmTooltip>
        </q-icon>
      </template>
    </RInput>
  </div>
</template>

<script>
export default {
  name: 'TextDateFilter',

  data: () => ({
    model: null
  }),

  methods: {
    valueChanged(newValue) {
      this.model = newValue
      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged('equals', newValue)
      })
    },

    onParentModelChanged(parentModel) {
      this.model = parentModel?.filter
    }
  }
}
</script>

<style lang="scss" scoped>
.text-date-filter {
  .info-icon {
    position: absolute;
    top: -0.5rem;
    right: 0;
    z-index: 2;
    background: white;
    border-radius: 50%;
    padding: 0;
    width: 1.2rem;
    height: 1.2rem;
  }
}
</style>
